import { IEditApkState } from './editApkContext';
import { EditApkActionTypes, TEditApkAction } from './editApkActions';

export const editApkReducer = (state: IEditApkState, action: TEditApkAction): IEditApkState => {
	switch (action.type) {
		case EditApkActionTypes.REFETCH_DATA:
			return {
				...state,
				needRefetchData: action.payload.needRefetch,
				fileData: {
					fileId: '',
					fileHash: null,
					fileName: null,
				},
			};
		case EditApkActionTypes.SET_INITIAL_FORM_DATA:
			return {
				...state,
				initialFormData: action.payload.initialFormData,
			};
		case EditApkActionTypes.SET_ALL_DATA:
			return {
				...state,
				apkID: action.payload.apkID,
				versionName: action.payload.versionName,
				versionCode: action.payload.versionCode,
				description: action.payload.description,
				applicationId: action.payload.applicationId,
				parameterOfApkType: action.payload.parameterOfApkType,
				IDSelectedApkType: action.payload.IDApkType,
				isCutoverBeforeUpdate: action.payload.isCutoverBeforeUpdate,
				filePath: action.payload.filePath,
			};
		case EditApkActionTypes.CHANGE_VERSION_NAME:
			return {
				...state,
				versionName: action.payload.versionName,
			};
		case EditApkActionTypes.CHANGE_VERSION_CODE:
			return {
				...state,
				versionCode: action.payload.versionCode,
			};
		case EditApkActionTypes.CHANGE_DESCRIPTION:
			return {
				...state,
				description: action.payload.description,
			};
		case EditApkActionTypes.CHANGE_APPLICATION_ID:
			return {
				...state,
				applicationId: action.payload.applicationId,
			};
		case EditApkActionTypes.SET_PARAMETER_OF_APK_TYPE:
			return {
				...state,
				parameterOfApkType: action.payload.parameterOfApkType,
				IDSelectedApkType: null,
				isCutoverBeforeUpdate: false,
			};
		case EditApkActionTypes.SET_ID_APK_TYPE:
			return {
				...state,
				IDSelectedApkType: action.payload.IDApkType,
				isCutoverBeforeUpdate: false,
			};
		case EditApkActionTypes.TOGGLE_CUTOVER_BEFORE_UPDATE:
			return {
				...state,
				isCutoverBeforeUpdate: !state.isCutoverBeforeUpdate,
			};
		case EditApkActionTypes.CHANGE_FILE_DATA:
			return {
				...state,
				fileData: action.payload.fileData,
			};
		case EditApkActionTypes.SET_DATA_FOR_SUBMIT:
			return {
				...state,
				dataForSubmit: action.payload.dataForSubmit,
			};
		case EditApkActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW:
			return {
				...state,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case EditApkActionTypes.RESET_FIELDS:
			return {
				...state,
				versionName: '',
				versionCode: '',
				description: '',
				applicationId: '',
				parameterOfApkType: null,
				IDSelectedApkType: null,
				isCutoverBeforeUpdate: false,
				fileData: {
					fileId: '',
					fileHash: null,
					fileName: null,
				},
				filePath: '',
			};
		default:
			return state;
	}
};
